<template>
  <div>
    <el-drawer
      :title="$l('dialog_title_editFabric') || '编辑面料'"
      :visible="visible"
      direction="rtl"
      :size="1200"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      @close="close()"
      @open="open()"
    >
      <div v-loading="loading">
        <div class="drawer-main">
          <Main ref="main" :data="list" @close="close()" @confirm="confirm" />
        </div>
        <div class="drawer-footer">
          <el-button size="small" @click="$refs.main.cancel()">
            {{ this.$l('INDEX.btn_cancel') || '取消' }}
          </el-button>
          <el-button type="primary" size="small" @click="$refs.main.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    devTrackingQuotationNo: { type: String, default: '' },
  },
  data() {
    return { list: [], loading: false, listbackup: [] }
  },
  mounted() {
    this.getData()
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async getData() {
      if (!this.devTrackingQuotationNo) return
      this.loading = true
      const res = await this.$api
        .customerDevTrackingQuotationFabricListApi({
          devTrackingQuotationNo: this.devTrackingQuotationNo,
        })
        .catch(() => null)
      this.loading = false
      const data = res?.body?.data || []
      this.list = data.map((item) => {
        const {
          fabricName,
          fabricColorTitle,
          defaultImageUrl,
          fabricWeight,
          v_fabricWeightUnit,
        } = item

        const displayFabricName = [fabricName, fabricColorTitle]
          .filter(Boolean)
          .join(' ')

        const displayFabricWeight = [fabricWeight, v_fabricWeightUnit]
          .filter(Boolean)
          .join(' ')

        const displayImageUrl = defaultImageUrl
          ? this.$osscdn(defaultImageUrl)
          : '/image/static/img/nopic.jpg'
        return {
          ...item,
          displayFabricName,
          displayFabricWeight,
          displayImageUrl,
        }
      })
      this.confirm(this.list)
    },
    confirm(data) {
      this.$emit('confirm', data)
      this.listbackup = JSON.parse(JSON.stringify(data || []))
    },
    open() {
      this.list = JSON.parse(JSON.stringify(this.listbackup || []))
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
